import React from 'react'

export default function ThumbsUpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5147 2.9254C10.7638 1.76287 9.8776 0.666668 8.6887 0.666668C8.25943 0.666668 7.8605 0.887801 7.63296 1.2518L4.66536 6H2.66536C1.92896 6 1.33203 6.59693 1.33203 7.33333V12.6667C1.33203 13.403 1.92896 14 2.66536 14H12.096C12.8535 14 13.546 13.572 13.8848 12.8944L15.0505 10.5631C15.2356 10.1928 15.332 9.78447 15.332 9.37049V7.33333C15.332 6.22873 14.4366 5.33333 13.332 5.33333H9.9987L10.5147 2.9254ZM4.66536 12.6667V7.33333H2.66536V12.6667H4.66536ZM8.73636 2.00207L5.9987 6.3824V12.6667H12.096C12.3485 12.6667 12.5793 12.524 12.6922 12.2981L13.8579 9.96677C13.9505 9.78163 13.9987 9.57748 13.9987 9.37049V7.33333C13.9987 6.96513 13.7002 6.66667 13.332 6.66667H9.9987C9.59604 6.66667 9.21496 6.48473 8.96183 6.1716C8.7087 5.85847 8.61056 5.44767 8.69496 5.05393L9.21096 2.646C9.27883 2.32927 9.05203 2.02973 8.73636 2.00207Z"
        fill="currentColor"
      />
    </svg>
  )
}
